import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './footer.component.html',
  standalone: true,
  imports: [RouterLink],
})
export class FooterComponent {
  @Input() isPublic = false;

  currYear = new Date().getFullYear();
}
